// removed by extract-text-webpack-plugin
module.exports = {"tiles":"tiles__tiles___KC-A0","tile":"tiles__tile___2TLkH","visual":"tiles__visual___257Wa","title":"tiles__title___cNo5R","fadein":"tiles__fadein___2XGE2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/tiles/tiles.scss
// module id = 398
// module chunks = 0